import React, { Component } from 'react';
import './ProgressBarItem.css';

class ProgressBarItem extends Component {
    render() {
        return (
            <li className={`progressBarItem ${this.props.buttonStatus}`}>
                <span className='progressBarItemSharp'></span>
                <span className='progressBarItemName'>{this.props.stepName}</span>
            </li>
        );
    }
}

export default ProgressBarItem;



// WEBPACK FOOTER //
// ./src/components/header/ProgressBarItem.jsx